import React from "react";
import useSearchParams from "../../../util/useSearchParams";
import EditForm from "./EditForm";
import ListForms from "./ListForms";


function Forms(){
    const [
        [form, setFormId]
    ] = useSearchParams({
        form: undefined
    });

    return form ? (
        <EditForm formId={form} setFormId={setFormId} />
    ) : (
        <ListForms setForm={setFormId} />
    );
}

export default Forms;